import { render } from "./InfosAffaire.vue?vue&type=template&id=392ec1e4"
import script from "./InfosAffaire.vue?vue&type=script&lang=js"
export * from "./InfosAffaire.vue?vue&type=script&lang=js"

import "./InfosAffaire.vue?vue&type=style&index=0&id=392ec1e4&lang=scss"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__